import AgendaSala from "@/model/AgendaSala";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/AgendaSala/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/AgendaSala/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pAgendaSala: AgendaSala) => {
        const response = await httpClient.post(`/AgendaSala/inserir`, pAgendaSala);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pAgendaSala: AgendaSala) => {
        const response = await httpClient.post(`/AgendaSala/alterar`, pAgendaSala);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`/AgendaSala/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },

});